import { useSavedItems } from './useSavedItems';
import { useAuth } from './useAuth';

const ENGAGED_THRESHOLD = 3;

/**
 * Centralized hook for tiered access gating based on saved item count.
 * - hasFirstSave: 1+ items saved (existing unlock for Try On, etc.)
 * - hasEngagedSaves: 3+ items saved (poll creation, commenting, studio premium tabs)
 */
export function useEngagementGate() {
  const { user, loading: authLoading } = useAuth();
  const { items, isLoading: itemsLoading } = useSavedItems();

  const savedCount = items.length;
  const hasFirstSave = savedCount >= 1;
  const hasEngagedSaves = savedCount >= ENGAGED_THRESHOLD;

  const isLoading = authLoading || (!!user && itemsLoading);

  return {
    savedCount,
    hasFirstSave,
    hasEngagedSaves,
    isLoading,
    threshold: ENGAGED_THRESHOLD,
  };
}
